import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/plans/')({
  component: PlansPage,
})

function PlansPage(): JSX.Element {
  return <div>Plan — placeholder</div>
}
